import type { SVGProps } from 'react';
export const SvgGlobalEdit = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={20}
		fill="none"
		viewBox="0 0 20 20"
		{...props}
	>
		<path
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.5}
			d="M18.333 10c0-4.6-3.733-8.333-8.333-8.333A8.336 8.336 0 0 0 1.667 10c0 4.6 3.733 8.334 8.333 8.334"
		/>
		<path
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.5}
			d="M6.667 2.5H7.5a23.7 23.7 0 0 0 0 15h-.833M12.5 2.5a23.8 23.8 0 0 1 1.217 7.5"
		/>
		<path
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.5}
			d="M2.5 13.333V12.5a23.8 23.8 0 0 0 7.5 1.217M2.5 7.5a23.7 23.7 0 0 1 15 0"
		/>
		<path
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit={10}
			strokeWidth={1.5}
			d="m16.008 13.116-2.95 2.95a1.03 1.03 0 0 0-.25.492l-.158 1.125c-.058.408.225.692.633.633l1.125-.158a1 1 0 0 0 .492-.25l2.95-2.95c.508-.508.75-1.1 0-1.85-.742-.742-1.333-.5-1.842.008"
		/>
		<path
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit={10}
			strokeWidth={1.5}
			d="M15.583 13.541c.25.9.95 1.6 1.85 1.85"
		/>
	</svg>
);
